import core_waybills_under_operations_module from '@components/monitor/.components/personal/core_waybills_under_operations/store.js'
import core_waybills_under_scans_module from '@components/monitor/.components/personal/core_waybills_under_scans/store.js'
import operations_module from '@components/monitor/.components/personal/operations/store.js'
const store = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
    },
    mutations: {
    }
}

export default store
